/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/interface-name-prefix */
import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import SeriesDetailLink from 'Components/links/series-detail'
import classnames from 'classnames'
import { useResponsive } from 'Components/hooks/use-responsive'
import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'
import SwiperButton from 'Components/swiper-button'
import { Image } from 'Components/view-image'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { logger } from 'lib/slardar-utils'
import TryCatchRender from 'Components/try-catch-render'

SwiperCore.use([Navigation])

export interface IPanoramicCar {
  ns_cover_url: string
  panoramic_url: string
  series_name: string
  series_id: number
}

interface ICarData {
  value: number | string
  text: string
  link: string
}

export interface ISeriesData {
  series_id: number
  series_name: string
  cover_url: string
  series_type: number //车系类型 0 轿车 1 suv 2 mvp
  is_new_energy: boolean // 是否是新能源
}
interface IConfig {
  [key: string]: {
    page: number
    types: number[]
  }
}

//   - 4列（1920）：4列*2行*6切=48个内容（最大值）
// - 3列（1680/1440/1280/1024）：3列*2行*8切=48个内容（最大值）

// - 1）4列（1920）: 每一组数据8个（轿车2、suv2、mpv 2、新能源2）；排序（轿车>suv>mpv>新能源）； 点击后跳转车系首页
// - 2) 3列（1680/1440/1280/1024）：每一组数据6个（轿车2、suv2、mpv1、新能源1）；排序（轿车>suv>mpv>新能源）；点击后跳转车系首页

const pageConfig: IConfig = {
  8: {
    page: 6,
    types: [2, 2, 2, 2],
  },
  6: {
    page: 8,
    types: [2, 2, 1, 1],
  },
}

const smNum = 6
const lgNum = 8

export const getCarAtlasData = async (req: any) => {
  const params = {
    limousine_pic_num: 16,
    suv_pic_num: 16,
    mpv_pic_num: 12,
    energy_pic_num: 12,
    panoramic_pic_num: 2,
    total_pic_num: 58,
  }
  const url = getUrl(`/motor/pc/car/rcm_picture?${serializeObject(params)}`)
  const json = await fetch(url, {
    req,
  }).catch((err) => {
    logger.warn(`[fetch] carAtlasData error. err=${err.message}`)
    return {}
  })
  const data = json?.data || {}
  return data
}

function CarAtlas() {
  const [frameTimes, setFrameTimes] = useState(pageConfig?.[smNum]?.['page'])

  const carList = [
    {
      value: 0,
      text: '轿车',
      link: 'key=series_type&param=0&text=轿车',
    },
    {
      value: 1,
      text: 'SUV',
      link: 'key=series_type&param=1&text=SUV',
    },
    {
      value: 2,
      text: 'MPV',
      link: 'key=series_type&param=2&text=MPV',
    },
    {
      value: 4,
      text: '跑车',
      link: 'key=series_type&param=4&text=跑车',
    },
    {
      value: 'xxx', // 等待添加参数
      text: '新能源',
      link: 'key=new_energy&param=1&text=新能源',
    },
    {
      value: 3,
      text: '皮卡',
      link: 'key=series_type&param=3&text=皮卡',
    },
    {
      value: 7,
      text: '微面',
      link: 'key=series_type&param=7&text=微面',
    },
    {
      value: 8,
      text: '微卡',
      link: 'key=series_type&param=8&text=微卡',
    },
    {
      value: 6,
      text: '轻客',
      link: 'key=series_type&param=6&text=轻客',
    },
  ]

  const [picNum, setPicNum] = useState<number>(smNum)
  const [swiperCarList, setSwiperCarList] = useState<ISeriesData[]>([])
  const responsive = useResponsive()

  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)

  const computedCarList = (num: number, seriesList: ISeriesData[]) => {
    const typeList: ISeriesData[][] = [[], [], []]
    const newEnergy: ISeriesData[] = []
    seriesList?.forEach((item) => {
      if (item?.is_new_energy) {
        newEnergy?.push(item)
      } else {
        if (typeList?.[item.series_type]) {
          typeList[item.series_type].push(item)
        }
      }
    })
    typeList?.push(newEnergy)
    let result: ISeriesData[] = []
    let isContinue = true
    let times = 0
    const currentPageConfig = pageConfig?.[num]
    while (isContinue) {
      let isAdd = true // 必须遍历添加完整的一组数组
      let tmp: ISeriesData[] = []
      currentPageConfig?.types?.forEach((value, index) => {
        if (typeList?.[index]?.length < value) {
          isAdd = false
          return
        }
        tmp = tmp.concat(typeList?.[index]?.splice(0, value))
      })
      if (isAdd) {
        result = result?.concat(tmp)
        times++
      } else {
        isContinue = false
      }
      if (result?.length >= currentPageConfig?.page * num) {
        isContinue = false
      }
    }
    setFrameTimes(times)
    setSwiperCarList(result)
    setPicNum(num)
  }

  const [seriesList, setSeriesList] = useState([])
  const [panoramicCarList, setPanoramicCarList] = useState([])
  useEffect(() => {
    let num = smNum
    if (responsive['2xl']) {
      num = lgNum
    }
    computedCarList(num, seriesList)
  }, [seriesList, panoramicCarList, responsive?.['2xl']])

  const [ref, inView] = useInView({
    threshold: 0,
  })

  useEffect(() => {
    async function init() {
      try {
        const data = await getCarAtlasData(null)
        setSeriesList(data?.nice_series_list || [])
        setPanoramicCarList(data?.panoramic_car_list || [])
      } catch (error) {
        logger.warn(`[fetch] carAtlasData error. err=${error.message}`)
      }
    }
    init()
  }, [])
  useEffect(() => {
    if (inView) {
      // - 精美车图 series_pic_module
      sendTeaCommEvent('show_event', {
        event_id: 'common_conponent_module',
        module_id: 'series_pic_module',
      })
    }
  }, [inView])
  /* 渲染车型的分类 */
  function renderCar(param: ICarData, index: number) {
    return (
      <Link
        href={`/picture?${param.link}`}
        key={`${index}-${param.value}`}
        as={`/picture?${param.link}`}
      >
        <a
          target="_blank"
          className="header-list-item fl"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'series_pic_module_keywords',
              module_id: 'series_pic_module',
              button_name: param.text,
            })
          }}
        >
          {param.text}
          <style jsx>
            {`
              .header-list-item {
                padding: 0 8px;
                font-size: 14px;
                border-right: 1px solid #979aa8;
                color: #606370;
                height: 20px;
                line-height: 20px;
              }
              :global(.sm .header-list-item) {
                padding: 0 4px;
              }
              .header-list-item:hover {
                color: #e62021;
              }
            `}
          </style>
        </a>
      </Link>
    )
  }

  function textLink(
    item: any,
    index: number,
    id: string,
    type: string,
    button_name?: string
  ) {
    return (
      <Link
        href={`/auto/images/detail?category=${type}&seriesId=${item?.series_id}`}
        as={`/auto/series/${item?.series_id}/images/${type}-x-x-x`}
      >
        <a
          target="_blank"
          className="g-active-white-text"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: id,
              car_series_id: `${item?.series_id}`,
              car_series_name: button_name || item?.series_name,
              rank: index,
              module_id: 'series_pic_module',
              button_name: button_name || '',
            })
          }}
        >
          <span>{button_name || item?.series_name}</span>
          <style jsx>
            {`
              span {
                padding: 0 4px;
              }
            `}
          </style>
        </a>
      </Link>
    )
  }

  /* 底部文字 */
  function renderTextLine(item: any, index: number) {
    return (
      <div className="series-name">
        <p className="name-title g-active-white-text g-one-line-text">
          {textLink(item, index, 'series_pic_module_series_text', '')}
        </p>
        <p className="series-link">
          {textLink(item, index, 'series_pic_module_pic_btn', 'wg', '外观')}|
          {textLink(item, index, 'series_pic_module_pic_btn', 'ns', '内饰')}|
          {textLink(item, index, 'series_pic_module_pic_btn', 'kj', '空间')}
        </p>
        <style jsx>
          {`
            .series-link {
              position: absolute;
              right: 16px;
              color: #fff;
            }
            .series-link a {
              padding: 0 4px;
            }
            .series-name {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              background-image: linear-gradient(
                to bottom,
                rgba(27, 28, 35, 0.54),
                rgba(14, 15, 22, 0.69)
              );
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              font-size: 12px;
              height: 33px;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div ref={ref} className="car-atlas-wrapper">
      <div className="car-atlas tw-col-span-3 2xl:tw-col-span-4">
        <div className="tw-grid tw-grid-cols-12 tw-gap-12 ">
          <div className="header car-atlas-header">
            <div className="title fl">
              <Link href="/picture" as={'/picture'}>
                <a
                  target="_blank"
                  onClick={() => {
                    sendTeaCommEvent('clk_event', {
                      event_id: 'series_pic_module_tilte',
                      module_id: 'series_pic_module',
                    })
                  }}
                >
                  精美车图
                </a>
              </Link>
            </div>
            <div className="header-list">
              {carList?.map((item: ICarData, index: number) =>
                renderCar(item, index)
              )}
              <Link href="/picture" as={'/picture'}>
                <a
                  target="_blank"
                  className="more"
                  onClick={() => {
                    sendTeaCommEvent('clk_event', {
                      event_id: 'series_pic_module_keywords',
                      module_id: 'series_pic_module',
                      button_name: '更多',
                    })
                  }}
                >
                  更多
                  <i className="more-icon icon-up-arrow-ic" />
                </a>
              </Link>
            </div>
          </div>
          <div className="car-atilas-swiper tw-col-span-12">
            {swiperCarList?.length ? (
              <Swiper
                speed={450}
                spaceBetween={12}
                watchOverflow={true}
                slidesPerView={1}
                slidesPerGroup={1}
                preventClicks={false}
                observeParents={true}
                observer={true}
                resizeObserver={true}
                navigation={{
                  nextEl: navigationNextRef.current,
                  prevEl: navigationPrevRef.current,
                }}
                simulateTouch={false}
                loop={false}
                onSlideChangeTransitionStart={(swiper) => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'series_pic_module_change',
                    module_id: 'series_pic_module',
                  })
                }}
              >
                {new Array(frameTimes)
                  .fill(undefined)
                  .map((noItem: number, index: number) => {
                    const currentIndex = index * picNum
                    const currectList = swiperCarList.slice(
                      currentIndex,
                      currentIndex + picNum
                    )
                    const seriesBig = swiperCarList[currentIndex]
                    return (
                      <SwiperSlide key={index}>
                        <div
                          className="atlas tw-grid tw-gap-12 tw-grid-cols-3 2xl:tw-grid-cols-4"
                          key={`${seriesBig?.series_id}-${index}`}
                        >
                          {currectList?.map((item, i) => (
                            <div
                              className="image-wrapper"
                              key={`${item?.series_id}-${i}`}
                            >
                              <div className="image-transition small-image-wrap g-load-img-wrap">
                                <SeriesDetailLink
                                  id={`${item?.series_id}`}
                                  onClick={() => {
                                    sendTeaCommEvent('clk_event', {
                                      event_id: 'series_pic_module_pic',
                                      car_series_id: `${item?.series_id}`,
                                      car_series_name: item?.series_name,
                                      rank: `${index}`,
                                      material_url: item?.cover_url,
                                      module_id: 'series_pic_module',
                                    })
                                  }}
                                >
                                  <Image
                                    src={item?.cover_url}
                                    alt={item?.series_name}
                                    lazy={true}
                                    width={660}
                                    height={422}
                                  />
                                </SeriesDetailLink>
                                {renderTextLine(item, index)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </SwiperSlide>
                    )
                  })}
                <SwiperButton
                  ref={navigationPrevRef}
                  type="prev"
                  buttonStyle={{
                    position: 'absolute',
                    right: '42px',
                    top: '3px',
                  }}
                />
                <SwiperButton
                  ref={navigationNextRef}
                  type="next"
                  buttonStyle={{
                    position: 'absolute',
                    right: '12px',
                    top: '3px',
                  }}
                />
              </Swiper>
            ) : (
              <div className="atlas empty-wrap">
                {new Array(8).fill(undefined).map((item, i) => (
                  <div className="image-wrapper" key={`empty-${i}`}>
                    <div
                      className={classnames(
                        'image-transition small-image-wrap g-load-img-wrap',
                        {
                          'bg-item': true,
                          'g-load-img-wrap': true,
                          'tw-hidden': i >= 6,
                          '2xl:tw-block': i >= 6,
                        }
                      )}
                    >
                      <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIvPg==" />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="car-pano-wrapper fr">
        <div className="header">
          <div
            className="title"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: '360_view_module_title',
                module_title: '360度看车',
                module_id: '360_view_module',
              })
            }}
          >
            360度看车
          </div>
        </div>
        {panoramicCarList?.length ? (
          panoramicCarList?.map(
            (panoramicCar: IPanoramicCar, index: number) => {
              return (
                <Link href={panoramicCar?.panoramic_url} key={index}>
                  <a
                    onClick={() => {
                      sendTeaCommEvent('clk_event', {
                        event_id: '360_view_module_item',
                        car_series_id: `${panoramicCar?.series_id}`,
                        car_series_name: panoramicCar?.series_name,
                        rank: `${index}`,
                        module_id: '360_view_module',
                      })
                    }}
                    target="_blank"
                  >
                    <div className="car-pano image-transition small-image-wrap g-load-img-wrap">
                      <div className="car-pano-mask" />
                      <Image
                        src={panoramicCar?.ns_cover_url}
                        lazy={true}
                        width={400}
                        height={280}
                        alt={panoramicCar?.series_name}
                        hoverTransition={false}
                      />
                      <div className="series-name">
                        <p className="name-title g-active-white-text g-one-line-text">
                          {panoramicCar?.series_name} - 360°全景内饰
                        </p>
                      </div>
                    </div>
                  </a>
                </Link>
              )
            }
          )
        ) : (
          <>
            <div className="car-pano image-transition small-image-wrap g-load-img-wrap" />
            <div className="car-pano image-transition small-image-wrap g-load-img-wrap" />
          </>
        )}
      </div>
      <style jsx>
        {`
          .car-atlas-wrapper {
            @apply tw-grid tw-gap-12 tw-grid-cols-4 2xl:tw-grid-cols-5 tw-w-full;
          }
          :global(.car-atlas-wrapper .swiper-container) {
            padding-top: 52px;
            box-sizing: content-box;
          }
          :global(.car-atlas-wrapper .left-section-link) {
            display: block;
            width: 100%;
            height: 100%;
          }
          .small-image-wrap {
            width: 100%;
            @apply tw-h-137 md:tw-h-172 lg:tw-h-185 xl:tw-h-211;
          }
          .empty-wrap {
            padding-top: 52px;
            @apply tw-grid tw-gap-12 tw-grid-cols-3 2xl:tw-grid-cols-4;
          }
          .car-atlas {
            width: 100%;
            overflow: hidden;
            position: relative;
          }
          .header {
            height: 36px;
            line-height: 36px;
            margin-bottom: 16px;
          }
          .car-atlas-header {
            position: absolute;
            z-index: 9;
            left: 0;
            right: 68px;
          }
          .header-list {
            line-height: 20px;
            height: 20px;
            padding-top: 9px;
            float: left;
          }
          .title {
            font-size: 20px;
            font-weight: 600;
            color: #1f2129;
            padding-right: 4px;
          }
          .more {
            padding: 0 8px;
            font-size: 14px;
            color: #606370;
            height: 20px;
            line-height: 20px;
            text-decoration: none;
          }
          .more:hover {
            color: #e62021;
          }
          .more-icon {
            margin-top: -2px;
            transform: rotate(90deg) scale(1.5);
          }
          .atlas {
            width: 100%;
          }
          .left-section {
            border-radius: 2px;
            height: 100%;
          }
          .right-section {
            display: flex;
            flex-wrap: wrap;
          }
          .right-section-img {
            width: 100%;
          }
          .image-transition {
            overflow: hidden;
            border-radius: 2px;
            position: relative;
            transition: transform 0.3s ease-in-out;
          }
          :global(.car-atlas-wrapper .image-transition img) {
            position: absolute;
            width: 100%;
            left: 50%;
            top: 50%;
            transition: transform 0.3s ease-in-out;
            transform: translate(-50%, -50%) scale(1.03);
          }
          :global(.car-atlas-wrapper .image-transition img:hover) {
            transform: translate(-50%, -50%) scale(1.1);
          }

          .series-name {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background-image: linear-gradient(
              to bottom,
              rgba(27, 28, 35, 0.54),
              rgba(14, 15, 22, 0.69)
            );
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 12px;
            height: 33px;
          }
          :global(.car-atlas-wrapper .car-pano .name-title) {
            width: calc(100% - 24px);
          }

          .left-section .series-name {
            height: 40px;
            font-weight: 500;
          }
          :global(.car-atlas-wrapper .name-title) {
            position: absolute;
            left: 12px;
            width: calc(100% - 136px);
            overflow: hidden;
          }
          .right-section .series-name {
            height: 32px;
            font-weight: 14px;
          }
          .car-pano {
            border-radius: 2px;
            overflow: hidden;
            position: relative;
            margin-bottom: 12px;
          }
          .car-pano-mask {
            background-color: rgba(0, 0, 0, 0.08);
            z-index: 100;
            position: absolute;
          }
          .panoramic-title {
            color: white;
            font-size: 16px;
            font-weight: 500;
            position: absolute;
            width: 100%;
            text-align: center;
            bottom: 9px;
          }
          .big-image::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40px;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              #1f2129
            );
          }
        `}
      </style>
    </div>
  )
}

export default TryCatchRender(CarAtlas)
